// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"Content_main_wrapper__19Rtu","objects_wrapper":"Content_objects_wrapper__2XtqO"};